export const getDateFormat1 = (reqDate, format) => {
  let tempDate = new Date(reqDate);
  let date = tempDate.getDate();
  let month = tempDate.getMonth();
  let year = tempDate.getFullYear();

  let newDate;
  newDate = `${month + 1}/${date}/${year}`;

  if (format && format === "yyyy/mm/dd") {
    newDate = `${year}/${month + 1}/${date}`;
  }

  return newDate;
};
